import { Fragment } from "react";
import CookieConsent from "react-cookie-consent";

function Cookie() {
  return (
    <Fragment>
      <CookieConsent
        onAccept={(acceptedByScrolling) => {
          if (acceptedByScrolling) {
            // triggered if user scrolls past threshold
            alert("Accept was triggered by user scrolling");
          } else {
            alert("Buona navigazione");
          }
        }}
        declineButtonText="Solo i necessari"
        setDeclineCookie
        enableDeclineButton
        onDecline={() => {
          alert(
            "Saranno utilizzati solo i cookie necessari per garantire la qualità del servizio, consigliamo a destra della barra degli indirizzi di toccare Altro, poi Informazioni e poi Cookie e lì selezionare Blocca cookie di terze parti "
          );
        }}
        location="bottom"
        buttonText="Perfetto!"
        cookieName="myAwesomeCookieName2"
        style={{ background: "#2B373B" }}
        buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
        expires={150}
      >
        Per la navigazione in questo sito sono utilizzati cookie tecnici e potrebbero essere presenti cookie di
        terze parti. Visita la sezione 'Privacy' per info.{" "}
      </CookieConsent>
    </Fragment>
  );
}

export default Cookie;
